<!-- icon-picker.component.html (sin Favoritos) -->
<div class="ipicker">
    <!-- selector compacto -->
    <button type="button" class="ip-select" (click)="toggle()" [attr.aria-expanded]="open">
        <i class="ip-icon" [class]="value || 'fas fa-question-circle'"></i>
        <span class="ip-text">{{ value || 'Seleccionar ícono' }}</span>
        <i class="fas fa-chevron-down ip-caret"></i>
    </button>

    <!-- panel -->
    <div class="ip-panel" *ngIf="open">
        <!-- búsqueda -->
        <div class="ip-searchbar">
            <i class="fas fa-search ip-sicon"></i>
            <input #searchInput class="ip-input" type="text" [placeholder]="placeholder" [(ngModel)]="query"
                (ngModelChange)="onQueryChange($event)" (keydown)="onKeyDown($event)" />
            <button class="ip-use" *ngIf="showUseButton" (click)="pasteManual()">Usar clase</button>
        </div>

        <!-- Recientes (sin favoritos) -->
        <div class="ip-quick" *ngIf="recent.length">
            <div class="ip-quick-row">
                <span class="ip-quick-title"><i class="fas fa-history"></i> Recientes</span>
                <div class="ip-chips">
                    <button class="ip-chip" *ngFor="let c of recent" (click)="pick(c)" [title]="c">
                        <span class="ico"><i [class]="c"></i></span>
                    </button>
                </div>
            </div>
        </div>

        <!-- resultados -->
        <div class="ip-grid ip-scroll" [class.ip-empty]="!results.length && !loading">
            <div class="cell" *ngFor="let r of results; let idx = index" [class.active]="idx===activeIndex"
                [title]="r.text">
                <button class="cell-btn" (click)="pick(r.text)">
                    <i [class]="r.text"></i>
                    <span class="cell-label">{{ labelFromClass(r.text) }}</span>
                </button>
            </div>

            <div class="ip-empty-msg" *ngIf="!results.length && !loading">
                <i class="far fa-frown"></i> Sin resultados
            </div>
        </div>

        <!-- pie -->
        <div class="ip-footer">
            <button class="ip-more" *ngIf="hasMore && !loading" (click)="loadMore()">Ver más</button>
            <div class="ip-loading" *ngIf="loading"><i class="fas fa-spinner fa-spin"></i> Cargando…</div>
        </div>
    </div>
</div>